import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LeiService from '../../../services/leis'
import InfiniteScroll from '../../../components/auth/utils/infiniteScroll';
import Lei from './lei';
import Moment from 'moment';


const ListarLeis = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    async function fetchLeis() {
        await seraQueAcabou();
        const response = await LeiService.categorias({ limit: true, cod_lei: cod, categoria: "Lei Municipal" });
        if (response.data.length >= 1) {
            let count = Math.floor(numLeis / 20) + 1
            for (let i = 1; i < count; i++) {
                setLeis([...leis, ...response.data])
                setCod(response.data[response.data.length-1]["cod_lei"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setLeis([])
            setVazio(true)
        }
    }

    const [leis, setLeis] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [cod, setCod] = useState(null);
    const [numLeis, setNumLeis] = useState(null);
    const [aindaTem, setAindaTem] = useState();



    async function fetchLeisIn() {
        await pegaNumLeis();
        const response = await LeiService.categorias({categoria: "Lei Municipal", limit: true});
        if (response.data.length >= 1) {
            setLeis(response.data)
            setVazio(false)
            setCod(response.data[response.data.length-1]["cod_lei"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setLeis([])
            setVazio(true)
        }
    }

    async function pegaNumLeis() {
        const response = await LeiService.numLeis({ todas: false, categoria: "Lei Municipal" })
        setNumLeis(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (leis.length >= numLeis + 1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }


    useEffect(() => {
        fetchLeisIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setLeis={setLeis}
                    setVazio={setVazio}
                    setAindaTem={setAindaTem}
                    fetchLeisIn={fetchLeisIn}
                    leis={leis}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {leis.map((lei, index) =>
                            <Lei
                                lei={lei}
                                key={index}
                            />
                        )}
                    </Row>
                    {aindaTem ?
                        <Fragment>
                            <p>Carregando mais leis...</p>
                            <InfiniteScroll Listar={fetchLeis} />
                        </Fragment>
                        : <p>Todas as leis já foram exibidas :)</p>}
                </Fragment>}
        </Fragment>

    )
}

export default ListarLeis;